export interface AveragePayConfig {
  method:
    | 'AVERAGE_PER_HOUR'
    | 'PERCENT_OF_TOTAL_PAY'
    | 'AVERAGE_PER_DAY'
    | (string & {});
  lookback?: string;
  percentValue?: number | null;
}

interface PayRuleConfig {
  payConfig?: { averagePayConfig?: AveragePayConfig };
}

export function getAveragePayConfig(payRule: {
  Config?: string | PayRuleConfig | null;
}): AveragePayConfig | undefined {
  const { Config } = payRule;
  if (typeof Config !== 'string') {
    return Config?.payConfig?.averagePayConfig;
  }
  try {
    const config: PayRuleConfig | null = JSON.parse(Config);
    return config?.payConfig?.averagePayConfig;
  } catch {
    return undefined;
  }
}
